import { Button } from '@heroui/react';
import { Container } from '@milestone-portal/ui/Container/Container';
import { useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { UndrawPageNotFound } from './UndrawPageNotFound';

export function NotFoundError() {
  const { t } = useTranslation('ui');
  const navigate = useNavigate();

  return (
    <Container className="flex items-center justify-center gap-y-8">
      <UndrawPageNotFound className="text-primary-500" />
      <h1 className="text-2xl font-bold">{t('pageNotFound')}</h1>
      <Button onPress={() => navigate({ to: '/' })}>{t('back')}</Button>
    </Container>
  );
}
